import { Card, Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { InfoCol } from '@components/InfoCol';
import type { PhoneNumberType } from '@customTypes/customer';
import { formatPhoneNumber } from '@utils/formats';

type Props = {
  item: PhoneNumberType,
}

const PhoneNumberCard = ({ item }: Props) => {
  const valueTextColor = item.talks_with_customer === false
    ? 'red.500'
    : (
      item.has_whatsapp === false
        ? { _light: 'yellow.600', _dark: 'yellow.400' }
        : undefined
    );

  return (
    <Card.Root
      size="sm"
      variant="subtle"
      p={4}
      key={item.phone_number}
      mt={4}
    >
      <Grid templateColumns="repeat(3, 1fr)" gap="4">
        <GridItem colSpan={{ base: 3, md: 1 }}>
          <Flex gap={1} flexDirection="column">
            <Text fontSize="sm" color="text.muted" fontWeight={600}>Telefone</Text>
            <Text fontSize="md" color={valueTextColor} textDecoration={item.talks_with_customer === false ? 'line-through' : 'none'}>
              {formatPhoneNumber(item.phone_number)}
            </Text>
          </Flex>
        </GridItem>
        <GridItem colSpan={{ base: 3, md: 1 }}>
          <InfoCol
            label="Tem WhatsApp?"
            value={item.has_whatsapp ? 'Sim' : 'Não'}
            mb={0}
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, md: 1 }}>
          <InfoCol
            label="Pertence ao cliente?"
            value={item.talks_with_customer ? 'Sim' : 'Não'}
            mb={0}
          />
        </GridItem>
      </Grid>
    </Card.Root>
  );
};

export default PhoneNumberCard;
